import {
  Box,
  Button,
  Dialog,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import React, { ReactNode } from 'react';



export type VerticleFilterModalLayoutProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
  title: string;
  subTitle?: string;
  cancelButton?: {
    handleClick: () => void;
  };
  successButton: {

    handleClick: () => void;
  };
  children: ReactNode | ReactNode[];
};

// type ITaskFilter = {
//   new: boolean;
//   assigned: boolean;
//   overdue: boolean;
//   inApproval: boolean;
//   completed: boolean;
// };

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: VerticleFilterModalLayoutProps) => {
  const theme = useTheme();
  return (
    <Dialog
      open={props.isVisible}
      onClose={() => props.handleClose()}
    >
      <Box
        sx={{
          minWidth: '12.5rem',
          marginBottom: '-1.25rem',
          marginX: '-1.25rem',
          padding: '0rem'
        }}

        display='flex'
        flexDirection='column'
      >
        <Box
          paddingX='.75rem'
          paddingTop='.75rem'
        >
          {props.title && (
            <Typography
              variant='modalTitle'
            >
              {props.title}
            </Typography>
          )}
        </Box>

        {/* FORM */}
        <Box
          paddingX='.75rem'
        >
          {props.children}
        </Box>

        <Stack

          direction='column'
        >
          <Box
            paddingY='.4rem'
            borderTop={`1px solid ${theme.palette.secondary.dark}`}
          >

            <Button
              fullWidth
              variant='text'
              onClick={() => props.cancelButton?.handleClick()}
            >
              Deselect All
            </Button>
          </Box>
          <Box
            bgcolor={theme.palette.primary.main}
          >
            <Button
              sx={{
                border: 'none'
              }}
              fullWidth
              variant='contained'
              onClick={() => props.successButton.handleClick()}
            >
              Apply Changes
            </Button>
          </Box>
        </Stack>
      </Box>

    </Dialog>
  );
};
